<script>   
    
   export default {
      
      data() {
         return {
            

            contact_id: null,
            vehicle_id: null,

            vehicle: {},
            token: '',
            loading: false,

         };
      },
      props: {      
         base_route: {
            type: String,
            default: () => {
               return "contacts"
            },
         }
      },
      mounted() {
         this.contact_id = this.$route.params.contact_id;
         this.vehicle_id = this.$route.params.vehicle_id;
         this.fetchDetails();
      },

      methods: {        

         fetchDetails() {
            let url = "api/hub/contacts/vehicles/details?id=" + this.vehicle_id;
            
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.vehicle = responseData.details;
               
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },       

      },
   }
</script>
    
<template>
               

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-7">
                        <h4 class="card-title mb-3">Vehicle Details</h4>
                        <div class="table-responsive">
                           <table class="table table-bordered mb-0">
                              
                              <tbody>
                                 <tr>
                                    <th>Vehicle No.</th>
                                    <td>{{vehicle.vehicle_number}}</td>
                                 </tr>
                                 <tr>
                                    <th>Manufacture Year</th>
                                    <td>{{vehicle.manufacturer}}</td>
                                 </tr>
                                 <tr>
                                    <th>Vehicle Type</th>
                                    <td>{{vehicle.converted_vehicle_type}}</td>
                                 </tr>
                                 <tr>
                                    <th>Carrier Type</th>
                                    <td>{{vehicle.converted_carrier_type}}</td>
                                 </tr>
                                 <tr>
                                    <th>Brand</th>
                                    <td>{{vehicle.brand}}</td>
                                 </tr>
                                 <tr>
                                    <th>Model</th>
                                    <td>{{vehicle.model}}</td>
                                 </tr>
                                 <tr>
                                    <th>Fuel Type</th>
                                    <td>{{vehicle.fuel_type}}</td>
                                 </tr>
                                 <tr>
                                    <th>Cubic Capacity (CC)</th>
                                    <td>{{vehicle.cubic_capacity}}</td>
                                 </tr>
                                 <tr>
                                    <th>GVW</th>
                                    <td>{{vehicle.gvw}}</td>
                                 </tr>
                                 <tr>
                                    <th>Hypothecation</th>
                                    <td>{{vehicle.hypothecation}}</td>
                                 </tr>
                                 <tr>
                                    <th>RTO</th>
                                    <td>{{vehicle.rto}}</td>                              
                                 </tr>
                       
                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div class=" col-md-6 col-lg-5">
                        <h4 class="card-title mb-3">Other Details</h4>
                        <div class="table-responsive">
                           <table class="table table-bordered mb-0">
                              <tbody>
                                 <tr>
                                    <th>Insurance Expiry Date</th>
                                    <td>{{vehicle.converted_insurance_expiry}}</td>
                                 </tr>
                                 <tr>
                                    <th>Fitness Expiry Date</th>
                                    <td>{{vehicle.converted_fitness_expiry}}</td>
                                 </tr>
                                 <tr>
                                    <th>Permit Expiry Date</th>
                                    <td>{{vehicle.converted_permit_expiry}}</td>
                                 </tr>
                                 <tr>
                                    <th>Tax Expiry Date</th>
                                    <td>{{vehicle.converted_tax_expiry}}</td>
                                 </tr>
                                 <tr>
                                    <th>Registration Renewal Date</th>
                                    <td>{{vehicle.converted_registration_renewal}}</td>
                                 </tr>                                 
                                 <tr>
                                    <th>Welfare Fund Renewal Date</th>
                                    <td>{{vehicle.converted_welfare_fund_renewal}}</td>
                                 </tr> 
                                 <tr v-if="vehicle.converted_sold_date">
                                    <th>Sold Date</th>
                                    <td>{{vehicle.converted_sold_date}}</td>
                                 </tr>                                 
                                 <tr>
                                    <th>Created on</th>
                                    <td>{{vehicle.converted_created_at}}</td>
                                 </tr>                       
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               
</template>
